import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ListGroupItem } from 'reactstrap';

import SettingsItemBoolean from './ItemBoolean';
import SettingsItemSelect from './ItemSelect';
import SettingsItemText from './ItemText';
import SettingsItemRekognition from './ItemRekognition';
import SettingsItemTeams from './ItemTeams';
import SettingsItemImageEditor from '../ContentSections/ImageEditor/ItemImageEditor';

const SettingsItem = ({
  settingKey,
  setting,
  handleSettingChange,
}) => {
  const handleChange = (e) => {
    const {
      value,
      type,
      checked,
    } = e.target;

    if (type === 'checkbox') {
      handleSettingChange(settingKey, checked);
    } else {
      handleSettingChange(settingKey, value);
    }
  };

  return (
    <ListGroupItem className={`list-group-item-setting-${setting.type}`}>
      {setting.type === 'boolean' && (
        <SettingsItemBoolean
          settingKey={settingKey}
          setting={setting}
          disabled={setting.gated}
          handleChange={handleChange}
        />
      )}
      {setting.type === 'select' && (
        <SettingsItemSelect
          settingKey={settingKey}
          setting={setting}
          disabled={setting.gated}
          handleChange={handleChange}
        />
      )}
      {setting.type === 'text' && (
        <SettingsItemText
          settingKey={settingKey}
          setting={setting}
          disabled={setting.gated}
          handleChange={handleChange}
        />
      )}
      {settingKey === 'rekognition_taxonomy' && (
        <SettingsItemRekognition
          settingKey={settingKey}
          setting={setting}
          disabled={setting.gated}
          handleChange={handleChange}
        />
      )}
      {settingKey === 'image_editor_presets' && (
        <SettingsItemImageEditor
          settingKey={settingKey}
          setting={setting}
          handleChange={handleSettingChange}
        />
      )}
      {settingKey === 'google_login_default_teams' && (
        <SettingsItemTeams
          settingKey={settingKey}
          setting={setting}
          disabled={setting.gated}
          handleChange={handleChange}
        />
      )}
    </ListGroupItem>
  );
};

const mapStateToProps = state => ({
  client: state.Auth.profile?.client,
  profile: state.Auth.profile,
});

SettingsItem.propTypes = {
  settingKey: PropTypes.string.isRequired,
  setting: PropTypes.object.isRequired,
  handleSettingChange: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(SettingsItem);
